module.exports = __WEBPACK_EXTERNAL_MODULE_1170__;


//////////////////
// WEBPACK FOOTER
// external "History"
// module id = 1170
// module chunks = 1